export default __webpack_public_path__ + "dist/media/Info.e4c60020.svg";